
/*
  helper util functions
*/

// obj to array
export const objectToArray = (obj) => {
  return  Object.keys(obj).map((k) => obj[k])
}

// obj to array, remove duplicates
export const objectToArrayClean = (obj) => {
  const arr = Object.keys(obj).map((k) => obj[k])
  return [...new Set(arr)];
}

// reduce array to match reference
export const filterArrayByReference = (arr, refArr) => {
  let res = [];
  res = arr.filter(el => {
    return refArr.find(ele => {
      return el.name === ele;
    });
  });
  return res;
}

// remove duplicates
export const getUniqueListBy = (arr, key) => {
  return [...new Map(arr.map(item => [item[key], item])).values()]
}

// chk object is not empty
export const chkObject = (object) => {
  return !!Object.keys(object)[0];
}

// chk device
export const chkDevice = (object) => {
  let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (isIOS) {
    return 'IOS_device'
  } else {
    return 'not_IOS_device'
  }
}
